export default {
  tour: {
    step: "PASO {n} DE {total}",
    skip: "Saltar tutorial",
    previous: "← Anterior",
    next: "Siguiente →",
    finish: "Terminar",
    welcomeTitle: "Bienvenido a HelixScan",
    welcomeBody: "HelixScan vigila por ti las fuentes oficiales del mercado farmacéutico español (AEMPS, BOE, SNS, CIPM, EMA…) y te avisa de los eventos que afectan a tus productos y a tu competencia. Este tutorial de 2 minutos te enseña lo esencial.",
    dashboardTitle: "Dashboard",
    dashboardBody: "Tu resumen diario: cuántos eventos se han detectado hoy y esta semana, cuáles afectan a tu portfolio o a tus competidores, el estado de cada fuente y la actividad de los últimos 7 días.",
    changesTitle: "Eventos detectados",
    changesBody: "Todos los eventos: precios, financiación, deducciones, exclusiones y avisos de seguridad. Filtra por tipo, prioridad o etiqueta, y haz clic en cualquier producto para abrir su ficha completa (CIMA + financiación + histórico).",
    historyTitle: "Histórico",
    historyBody: "Archivo mensual de eventos desde 2010. Haz clic en un día para ver exactamente qué cambió esa fecha.",
    radarTitle: "Radar Regulatorio",
    radarBody: "Los eventos regulatorios del mes en 4 carriles: precios, financiación, autorizaciones y regulatorio (CMH, SPRAH, EMA, BOE…). Ideal para preparar el comité mensual.",
    productsTitle: "Mis Productos",
    productsBody: "Tu portfolio. Los eventos que afecten a estos productos se marcan con la etiqueta de tu organización y reciben prioridad alta.",
    competitorsTitle: "Competidores",
    competitorsBody: "Productos de la competencia que quieres vigilar: directos (misma molécula) y terapéuticos (misma área). Sus eventos se marcan como Competidor.",
    alertsTitle: "Avisos por correo",
    alertsBody: "Suscríbete a tipos de cambio o principios activos concretos y recibe un email en cuanto se detecten. También hay un resumen diario configurable en Preferencias.",
    trendsTitle: "Predicciones",
    trendsBody: "Modelos de previsión de precio por producto basados en 15 años de histórico: riesgo de subida/caída, oportunidades y eventos que explican cada movimiento.",
    pricesTitle: "Comparador de Precios",
    pricesBody: "Compara la evolución del PVL de tus productos con la de todos los competidores de la misma molécula, con 15 años de histórico de precios SNS.",
    sourcesTitle: "Fuentes",
    sourcesBody: "Las fuentes oficiales monitorizadas, su frecuencia y su última revisión. HelixScan las sondea automáticamente cada 30 minutos en horario laboral.",
    doneTitle: "¡Listo!",
    doneBody: "Ya conoces lo esencial. Puedes volver a ver este tutorial cuando quieras desde el botón ? de la barra superior. Si tu portfolio aún está vacío, configúralo en Mis Productos.",
  },
};
